import { pipe, filter, propEq, sortBy, prop } from 'ramda'
import { makeObj } from '@/vue/util/briqRamdaExt'

const filterAndSortBookingSegments = (segmentsOnBooking, segments) => {
  const enabledBookingSegments = pipe(
    filter(propEq('Enabled', true)),
    sortBy(prop('Ordering')),
  )(segments)

  return complementSegmentsOnBooking(enabledBookingSegments, segmentsOnBooking)
}

const appendSegment = makeObj({
  SegmentCode: prop('Code'),
  NumberOfPersons: () => 0,
  SegmentNamePlural: prop('NamePlural'),
})

const uniqueSegmentsArray = (array, byKey) =>
  array.reduce((unique, o) => {
    if (!unique.some(obj => obj[byKey] === o[byKey])) unique.push(o)
    return unique
  }, [])

const complementSegmentsOnBooking = (enabledBookingSegments, segmentsOnBooking) => {
  let arrayOfSegments = []
  enabledBookingSegments.forEach(enabledBookingSegment => {
    segmentsOnBooking.forEach(segmentOnBooking => {
      if (segmentOnBooking.SegmentCode === enabledBookingSegment.Code) {
        return arrayOfSegments.push(segmentOnBooking)
      }
    })
    return arrayOfSegments.push(appendSegment(enabledBookingSegment))
  })
  return uniqueSegmentsArray(arrayOfSegments, 'SegmentCode')
}

export default filterAndSortBookingSegments
